'use client'
import { TToastDialogProps } from '@populix/pop-ui'
import { useCallback, useContext } from 'react'

import { ToastDialogContext, defaultToastDialogState } from '../providers/toast-dialog-providers'

const useToastDialog = () => {
  const toastDialog = useContext(ToastDialogContext)

  const close = useCallback(() => {
    if (toastDialog?.setState) {
      const { setState } = toastDialog

      setState(defaultToastDialogState)
    }
  }, [toastDialog])

  const show = useCallback(
    ({
      autoclose = true,
      ...state
    }: Omit<TToastDialogProps, 'show'> & {
      autoCloseDuration?: number
      autoclose?: boolean
    }) => {
      if (toastDialog?.setState) {
        const { setState } = toastDialog

        setState({ show: true, ...state })

        if (autoclose) {
          setTimeout(
            () => {
              setState({ ...defaultToastDialogState })
            },
            state?.autoCloseDuration ?? 5000,
          )
        }
      }
    },
    [toastDialog],
  )

  return {
    show,
    close,
  }
}

export default useToastDialog
